import type { Theme } from '@mui/material/styles/createTheme';
import type { FC } from 'react';

import { SvgIcon, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import useMediaQuery from '@mui/material/useMediaQuery';
import { alpha } from '@mui/system/colorManipulator';
import { useGetUserInfo } from 'src/api/user';
import Iconify from 'src/components/iconify';
import { useSettings } from 'src/hooks/use-settings';

import { AccountButton } from '../account-button';

const TOP_NAV_HEIGHT = 64;
const SIDE_NAV_WIDTH = 280;
const COLLAPSED_SIDE_NAV_WIDTH = 88;

interface TopNavProps {
  onMobileNavOpen?: () => void;
}

export const TopNav: FC<TopNavProps> = props => {
  const { onMobileNavOpen, ...other } = props;
  const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));
  const { data: userInfoData } = useGetUserInfo({ enabled: false });
  const { sidebarCollapsed, handleSidebarCollapse } = useSettings();

  return (
    <Box
      component="header"
      sx={{
        backdropFilter: 'blur(6px)',
        backgroundColor: theme => alpha(theme.palette.background.default, 0.8),
        position: 'sticky',
        left: {
          lg: `${sidebarCollapsed ? COLLAPSED_SIDE_NAV_WIDTH : SIDE_NAV_WIDTH}px`,
        },
        top: 0,
        boxShadow: 10,
        zIndex: theme => theme.zIndex.appBar,
        transition: theme =>
          theme.transitions.create('left', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
      }}
      {...other}
    >
      <Stack
        alignItems="center"
        spacing={2}
        direction="row"
        justifyContent="space-between"
        sx={{
          minHeight: TOP_NAV_HEIGHT,
          px: 2,
          marginLeft: lgUp ? (sidebarCollapsed ? 10 : 35) : 0,
        }}
      >
        <Stack
          alignItems="center"
          spacing={2}
          direction="row"
          sx={{
            width: '100%',
          }}
        >
          {!lgUp && (
            <IconButton onClick={onMobileNavOpen}>
              <SvgIcon>
                <Iconify icon="material-symbols:menu" />
              </SvgIcon>
            </IconButton>
          )}
          {lgUp && (
            <IconButton onClick={handleSidebarCollapse}>
              <SvgIcon>
                <Iconify
                  icon={
                    sidebarCollapsed
                      ? 'material-symbols:menu-open'
                      : 'material-symbols:menu'
                  }
                />
              </SvgIcon>
            </IconButton>
          )}
          {userInfoData?.data.type !== 8 && (
            <Typography>{userInfoData?.data.current_group_name}</Typography>
          )}
          {/* <SearchButton /> */}
        </Stack>
        <Stack alignItems="center" spacing={2} direction="row">
          {/* <NotificationsButton /> */}
          {/* <ContactsButton /> */}
          <AccountButton />
        </Stack>
      </Stack>
    </Box>
  );
};
